import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=55d2ecb0&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d2ecb0')) {
      api.createRecord('55d2ecb0', component.options)
    } else {
      api.reload('55d2ecb0', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=55d2ecb0&", function () {
      api.rerender('55d2ecb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sHEF85j150bo/JS/comp/currencymod.vue"
export default component.exports